import React, { Component } from 'react';
import { Fade } from 'react-reveal';
import Project from '../../components/Project';
import './Projects.css';
import * as selected from './selected.json';
export default class Projects extends Component {

  componentDidMount() {
    this.props.setPage("applications");
  }

  render() {
    return (
      <div className="projects">
        <h1>Applications Built</h1>
        <Fade>
          {JSON.parse(JSON.stringify(selected)).map((data, i) => (
            <div key={i}>
              <Project key={i} id={i} data={data} />
            </div>
          ))}
        </Fade>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Projects/Projects.js